import { Button } from '@octane/spark'
import styled from 'styled-components'

export const Banner = styled.div<{ $background: string }>`
    display: flex;
    min-height: 120px;
    align-items: center;
    justify-content: center;
    gap: 21px;
    padding: 20px;
    background: ${({ $background }) => $background};
    border: 1px solid #d5d9e0;
    border-radius: 5px;

    @media (max-width: 768px) {
        align-items: stretch;
        flex-direction: column;
    }
`

export const Logo = styled.img`
    width: 135px;
    height: 54px;
    flex-shrink: 0;

    @media (max-width: 768px) {
        align-self: flex-start;
    }
`

export const TextSection = styled.div`
    flex: 0 0 auto;
`

export const Description = styled.p<{ $color: string }>`
    width: 200px;
    margin: 0;
    color: ${({ $color }) => $color};
    font-family: 'Open Sans', sans-serif;
    font-size: 14px;
    font-weight: 700;
    line-height: 1.3;

    @media (max-width: 768px) {
        width: auto;
    }
`

export const CtaButton = styled(Button)<{
    $background: string
    $backgroundHover: string
    $color: string
}>`
    width: 233px;
    height: 36px;
    padding: 8px 20px;
    background: ${({ $background }) => $background};
    border-color: ${({ $background }) => $background};
    border-radius: 5px;
    color: ${({ $color }) => $color};
    font-family: 'Nunito Sans', sans-serif;
    font-size: 16px;
    font-weight: 700;
    line-height: 1.65;
    white-space: nowrap;

    &:hover {
        background: ${({ $backgroundHover }) => $backgroundHover};
        border-color: ${({ $backgroundHover }) => $backgroundHover};
        color: ${({ $color }) => $color};
    }

    &:active {
        background: ${({ $background }) => $background};
        border-color: ${({ $background }) => $background};
        color: ${({ $color }) => $color};
    }

    @media (max-width: 768px) {
        width: 100%;
    }
`
